import angular from 'angular'
import modal from 'angular-ui-bootstrap/src/modal'
import pagination from 'angular-ui-bootstrap/src/pagination'
import {
    user
} from 'redevConfig'
import userModalInstanceCtrl from './userModalInstanceCtrl'
import ModalDemoCtrl from './ModalDemoCtrl'

const add = (user && user.add) || ''
const edit = (user && user.edit) || ''
const list = (user && user.list) || ''

const userListCtrl = list ? require(`redevelopment/system/user/${list.controllerName}`) : require('./userListCtrl')
const addUserCtrl = add ? require(`redevelopment/system/user/${add.controllerName}`) : require('./add_userCtrl')
const editUserCtrl = edit ? require(`redevelopment/system/user/${edit.controllerName}`) : require('./edit_userCtrl')

const userListPage = list ? require(`redevelopment/system/user/${list.templateName}`) : require('./view/userList.html')
const addUserPage = add ? require(`redevelopment/system/user/${add.templateName}`) : require('./view/add_userInfo.html')
const editUserPage = edit ? require(`redevelopment/system/user/${edit.templateName}`) : require('./view/edit_userInfo.html')

export default angular
    .module('system.permission.user', [modal, pagination])
    .config(['$stateProvider', function config ($stateProvider) {
        $stateProvider.state('system.permission.user', {
            url: '/user',
            template: '<div ui-view></div>',
            abstract: true,
            title: '用户管理',
            default: 'system.permission.user.list',
        })
        $stateProvider.state('system.permission.user.list', {
            url: '/list/:search',
            template: userListPage,
            controller: 'userListCtrl',
        })
        $stateProvider.state('system.permission.user.add', {
            url: '/add/:orgId',
            template: addUserPage,
            controller: 'addUserCtrl',
            title: '新增',
        })
        $stateProvider.state('system.permission.user.edit', {
            url: '/edit/:userId',
            template: editUserPage,
            controller: 'editUserCtrl',
            title: '编辑用户',
        })
    }])
    .controller('userListCtrl', userListCtrl.default)
    .controller('addUserCtrl', addUserCtrl.default)
    .controller('editUserCtrl', editUserCtrl.default)
    .controller('userModalInstanceCtrl', userModalInstanceCtrl)
    .controller('ModalDemoCtrl', ModalDemoCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/permission/user/index.js